import { Button, Colors, IcPlus, IcSynchronize, InputSearch, Row, Text } from 'basic-ui-lib';
import useGetListStores from 'modules/store/services/hooks/useGetListStore';
import styled from 'styled-components';
import NewStoreModal, { useNewStoreModalRef } from 'modules/store/screens/Create/NewStoreModal';
import SyncStoreModal, { useSyncStoreModalRef } from '../SyncStoreModal';
import { useMediaQuery } from 'react-responsive';
import useDebounce from 'hooks/useDebounce';
import { useCallback } from 'react';

const StoreFilter = () => {
  const newStoreModalRef = useNewStoreModalRef();
  const syncStoreModalRef = useSyncStoreModalRef();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleOpenModal = () => {
    newStoreModalRef.current?.open();
  };
  const { storesList, mutate, params } = useGetListStores(true);

  const handleSearch = useCallback((searchText: string) => {
    mutate({ ...params, keySearch: searchText || undefined });
  }, []);

  const { text: searchValue, setText: setSearchValue } = useDebounce({
    value: '',
    timeDebounce: 500,
    onDebounce: handleSearch,
  });

  if (isMobile) {
    return (
      <>
        <ContainerMobile>
          <Row width='100%' justifyContent='space-between'>
            <Text title_h2 semibold>
              Stores ({storesList?.totalElements || 0})
            </Text>
            <Button
              type_primary
              lg
              type='button'
              prefix={<IcSynchronize fill={Colors.neutral.bg[1]} width={20} height={20} />}
              onClick={() => syncStoreModalRef.current?.open()}
            >
              Sync Store
            </Button>
          </Row>
          <InputSearch value={searchValue} onChange={setSearchValue} placeholder='Search business name/phone' />
        </ContainerMobile>
        <SyncStoreModal ref={syncStoreModalRef} onSuccess={() => mutate({ ...params })} />
      </>
    );
  }
  return (
    <Container>
      <Row width='45%'>
        <Text title_h2 semibold>
          Stores ({storesList?.totalElements || 0})
        </Text>
      </Row>
      <Row gap={16} width='55%' justifyContent='flex-end'>
        <InputSearch value={searchValue} onChange={setSearchValue} placeholder='Search business name/phone' />
        <Button
          type_primary
          lg
          type='button'
          prefix={<IcSynchronize fill={Colors.neutral.bg[1]} width={20} height={20} />}
          onClick={() => syncStoreModalRef.current?.open()}
        >
          Sync Store
        </Button>
        <Button
          type_second
          lg
          type='button'
          prefix={<IcPlus fill={Colors.neutral.bg[1]} width={20} height={20} />}
          onClick={handleOpenModal}
        >
          Add Store
        </Button>
      </Row>

      <NewStoreModal ref={newStoreModalRef} />
      <SyncStoreModal ref={syncStoreModalRef} onSuccess={() => mutate({ ...params })} />
    </Container>
  );
};

export default StoreFilter;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .custom-text {
    white-space: nowrap;
  }

  .input-search {
    width: 490px;
  }
`;

const ContainerMobile = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 24px;
`;
